const BACKDROP_SPINNER = 'modal-backdrop--spinner';
export function loadSpinner() {
    let $body = $('body');
    let spinner = `<div class="modal-backdrop fade show ${BACKDROP_SPINNER}"><i class="fas fa-spinner isa-spinner fa-spin"></i></div>`;
    $body.append(spinner);
}

export function stopSpinner() {
    let $modalSpinner = $(`.${BACKDROP_SPINNER}`);
    $modalSpinner.remove();
}

export function startLoadingSpinner(container) {
    let spinner = `<div class="isa-spinner isa-spinner--loading"><i class="fas fa-circle-notch fa-spin isa-spinner__icon" role="status" aria-hidden="true"></i></div>`;
    container.append(spinner);
}

export function stopLoadingSpinner(container) {
    let spinner = $('.isa-spinner--loading');
    container.find(spinner).remove();
}
